import { render, staticRenderFns } from "./c-selectable-menu.vue?vue&type=template&id=95c8190e&scoped=true&"
import script from "./c-selectable-menu.vue?vue&type=script&lang=js&"
export * from "./c-selectable-menu.vue?vue&type=script&lang=js&"
import style0 from "./c-selectable-menu.vue?vue&type=style&index=0&id=95c8190e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c8190e",
  null
  
)

export default component.exports